const getters = {
  collapse: state => state.app.collapse
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js